import React, { useRef } from 'react';
import './contacts.css';
import { MdOutlineMail } from 'react-icons/md';
import { RiMessengerLine } from 'react-icons/ri';
import { BsWhatsapp } from 'react-icons/bs';
import emailjs from 'emailjs-com';

const Contacts = () => {
  const form = useRef();

  const sendEmail = async (e) => {
    e.preventDefault();

    // Show confirmation dialog
    const confirmSubmission = window.confirm("Are you sure you want to send this message?");
    if (!confirmSubmission) {
      return; // Cancel submission if the user clicks "Cancel"
    }

    try {
      // Wait for the email to be sent
      const result = await emailjs.sendForm('service_nigw33m', 'template_jbbnm6j', form.current, 'CwcdqJ0QB4yWXKJaX');
      console.log(result.text);
      alert("Message sent successfully!"); // Show success message
      e.target.reset(); // Reset form after successful submission
    } catch (error) {
      console.error(error.text);
      alert("Failed to send the message. Please try again."); // Show failure message
    }
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact__container">
        <div className="contact__options">
          <article className="contact__option">
            <MdOutlineMail className='contact__option-icon' />
            <h4>Email</h4>
            <a href="mailto:parthamchawla1@gmail.com">parthamchawla1@gmail.com</a>
          </article>

          <article className="contact__option">
            <RiMessengerLine className='contact__option-icon' />
            <h5>Partham Chawla</h5>
            <a href="https://m.me/partham.chawla.313/" target='_blank' rel="noreferrer">Send a message</a>
          </article>

          <article className="contact__option">
            <BsWhatsapp className='contact__option-icon' />
            <h4>WhatsApp</h4>
            <a href="https://api.whatsapp.com/send?phone=+923193428730" target='_blank' rel="noreferrer">Send a message</a>
          </article>
        </div>

        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required />
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary'>Send Message</button>
        </form>
      </div>
    </section>
  );
};

export default Contacts;
